const SettingPushNotificationScreen = () => null

export default SettingPushNotificationScreen
